import { observer } from 'mobx-react-lite';
import { ReactElement, useMemo } from 'react';
import { ColumnLayout } from '../../../common/layouts/columnLayout/ColumnLayout';
import { RowLayout } from '../../../common/layouts/rowLayout/RowLayout';
import { IChartPoint, ITrainingResult } from '../../jobMetrics.model';
import { IValidJobType, JOB_STATUS, JOB_TYPE, TRAINING_VARIANT } from '../../jobs.model';
import { IJobThreshold } from '../../jobThreshold.store';
import { LossMetrics } from './contents/LossMetrics';
import { MetricsBase } from './contents/MetricsBase';
import { ResultsTable } from './contents/ResultsTable';

interface IProps {
  jobType: IValidJobType;
  variant: TRAINING_VARIANT;
  loss: IChartPoint[];
  validationAccuracy: IChartPoint[];
  trainingAccuracy: IChartPoint[];
  results: ITrainingResult[];
  status: JOB_STATUS;
  recalculateMetrics?: (min: number, max: number) => void;
  threshold?: IJobThreshold | null;
  saveThresholds?: (min: number, max: number) => void;
}

export const AnomalyDetection = observer((props: IProps): ReactElement => {
  const { jobType, variant, results, status, loss, validationAccuracy, trainingAccuracy, recalculateMetrics, saveThresholds, threshold } = props;

  const lossMetrics = useMemo(
    () => (
      <LossMetrics
        loss={loss}
        validationAccuracy={validationAccuracy}
        trainingAccuracy={trainingAccuracy}
        status={status}
      />
    ),
    [loss, validationAccuracy, trainingAccuracy]
  );

  return (
    <>
      {jobType === JOB_TYPE.TRAINING && variant === TRAINING_VARIANT.ANOMALY_DETECTION_4 && lossMetrics}
      <MetricsBase
        jobType={jobType}
        recalculateMetrics={recalculateMetrics}
        threshold={threshold}
        saveThresholds={saveThresholds}
        status={status}
      >
        <RowLayout
          size='md'
          className='metrics-row-base'
        >
          <ColumnLayout size='md'>
            <ResultsTable
              jobType={jobType}
              results={results}
              status={status}
            />
          </ColumnLayout>
        </RowLayout>
      </MetricsBase>
    </>
  );
});
